export default function (sectionId: any, visibleSections: any) {
  if (sectionId) {
    return visibleSections.indexOf(sectionId) !== -1;
  }
  return true;
}